
<template>
  <img
    v-if="src"
    ref="imgRef"
    class="img"
    :src="src"
    :style="{
      ...imgStyle,
      ...style,
    }"
    @error="onError"
    @binderror="onError"
  >
</template>

<script setup lang="ts">
import { onMounted, ref, nextTick, watch } from 'vue';
import { svgTag } from '@/common/dom';

const props = defineProps({
  src: {
    type: String,
    default: '',
  },
  /**
   * imgage染色场景具体监测对象
   */
  watchKey: {
    type: String,
    default: '',
  },
  imgStyle: {
    type: Object,
    default: () => {},
  },
});

// const defaultSrc = ref('https://vfiles.gtimg.cn/vupload/20210715/e46c761626343980653.png');
const imgRef = ref();
const  style = ref({});
const isEvo = import.meta.env.EVO;
const emit = defineEmits(['loadError']);


const getFilter = (r: number, g: number, b: number): string => {
  const name = ['color', 'filter', r, g, b].join('-');
  const el = document.getElementById(name);
  if (!el) {
    const svg = svgTag('svg', { style: 'position: fixed; top: -1000px; left: -1000px; width: 0; height: 0;' }, [
      svgTag('defs', {}, [
        svgTag('filter', { id: name }, [
          svgTag('feColorMatrix', {
            type: 'matrix',
            values: `0 0 0 0 ${r / 255} 0 0 0 0 ${g / 255} 0 0 0 0 ${b / 255} 0 0 0 1 0`,
            'color-interpolation-filters': 'sRGB',
          }),
        ]),
      ]),
    ]);
    if (!svg) return '';
    document.body.appendChild(svg);
  }
  return `url(#${name})`;
};
const adaptTintColor = () => {
  if (!imgRef.value) {
    return;
  }
  try {
    const color = getComputedStyle(imgRef.value).getPropertyValue('--tint-color') || imgRef.value?.style?.tintColor;
    if (!color) {
      return;
    }
    const el = document.createElement('div');
    el.style.color = color;
    // 类似red之类的字面值不支持，其他都会变rgb
    const [r, g, b] = el.style.color.split('(')?.[1]?.split(')')?.[0]?.split(',')?.map(Number) ?? [];
    let filter = '';
    if (b !== undefined) {
      filter = getFilter(r, g, b);
    }
    style.value = { filter };
  } catch (error) {
    console.error('[components/image-view/adaptTintColor]', 'failed to adapt tint color', error);
  }
};

const onError = () => {
  emit('loadError');
};

watch(() => props.watchKey, (newVal, oldVal) => {
  if (newVal !== oldVal && !isEvo) {
    nextTick(() => {
      adaptTintColor();
    });
  }
});

onMounted(() => {
  if (!isEvo) {
    adaptTintColor();
  }
});

</script>

